import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { useDispatch, useSelector } from 'react-redux'
import localStorage from 'redux-persist/lib/storage'
import { persistStore, persistReducer, PERSIST, REHYDRATE, FLUSH, PAUSE, PURGE, REGISTER } from 'redux-persist'
import AuthReducer from '../../features/auth/slices/authSlice'
import baseApi from '../api/baseApi'
import sensorStatusNameReducer from '../../components/main/slice/sensorStatusNameSlice'
import { sensorDataReducer } from '../../components/main/slice/sensorDataSlice'
import sensorDashboardReducer from '../../components/main/slice/sensorDashboardSlice'
import myProfileReducer from '../../components/common/slice/myProfileSlice'
import passwordChangeReducer from '../../components/common/slice/passwordChangeSlice'
import sensorReducer from '../../components/sensor/slice'

const persistConfig = {
    key: 'root',
    storage: localStorage,
    whitelist: ['user'],
}

const rootReducer = combineReducers({
    [baseApi.reducerPath]: baseApi.reducer,
    sensorStatusName: sensorStatusNameReducer,
    sensorData: sensorDataReducer,
    sensorDashboard: sensorDashboardReducer,
    myProfile: myProfileReducer,
    passwordChange: passwordChangeReducer,
    sensorState: sensorReducer
})


export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: [
                    FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER
                ],
            },
        }).concat(baseApi.middleware as any),
})

// export const persistor = persistStore(store)

export type RootState = ReturnType<typeof rootReducer>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()